<template>
  <billing-report-panel
    report-key="production-professional"
    route="/reports/billing-production-professional"
    file-name="producao-por-profissional.xlsx"
    period-label="Período do atendimento"
    :columns="columns"
    :default-days="30"
    show-professional
  />
</template>

<script>
import BillingReportPanel from './BillingReportPanel.vue';

export default {
  components: {
    BillingReportPanel,
  },
  data() {
    return {
      columns: [
        'Especialidade',
        'Profissional',
        'Itens realizados',
        'Pacientes atendidos',
        'Valor de convênio',
        'Valor particular',
        'Total do profissional',
        'Subtotal por especialidade',
      ],
    };
  },
};
</script>
